<template>
    <div class="guideRoot">
        <div class="titleBlock"  v-if="currentPage ==-1">
            <div style="position: fixed;left: 0;top:0;width: 100%;z-index: 1999;">
                <HeaderVue @handleIdChange="gotoAnchor"></HeaderVue>
            </div>
            <!-- <div class="titleLogo"   @click="gotoHome">
                <img :src="imgObj.paperLogo" style="width: 100%;height: 100%;" alt="">
            </div>
            <div class="titleRight"   @click="gotoHome">
                <div class="mainTitle">{{ $t('headerModule.mainTitle')}}</div>
                <div class="subTitle">{{$t('headerModule.subTitle')}}</div>
            </div> -->
        </div>
        <div class="itemBlock">
            <vue-page-transition name="overlay-left-full" style="width: 100%;height: 100%;">
            <GuideOne v-if="currentPage ==-1" @changePage="handlePagechange"></GuideOne>
            <GuideTwo v-else-if="currentPage==0" @changePage="handlePagechange"></GuideTwo>
            <StepOne v-else-if="currentPage==1" @changePage="handlePagechange"></StepOne>
            <StepTwo v-else-if="currentPage==2" @changePage="handlePagechange"></StepTwo>
            <StepThree v-else-if="currentPage==3" @changePage="handlePagechange"></StepThree>
            <StepFour v-else-if="currentPage==4" @changePage="handlePagechange"></StepFour>
            <StepFive v-else-if="currentPage==5" @changePage="handlePagechange"></StepFive>
            <StepSix v-else-if="currentPage==6||currentPage==7" @changePage="handlePagechange"></StepSix>
            <!-- <StepSeven v-else-if="currentPage==7" @changePage="handlePagechange"></StepSeven> -->
            <StepEight v-else-if="currentPage==8" @changePage="handlePagechange"></StepEight>
            <NineVue v-else-if="currentPage==9" @changePage="handlePagechange"></NineVue>
        </vue-page-transition>

        </div>

        <CookieVue/>
    </div>
</template>
<script>
import GuideOne from './guideOne.vue'
import GuideTwo from './guideTwo.vue'
import  StepOne from './stepOne.vue'
import  StepTwo from './stepTwo.vue'
import  StepThree from './stepThree.vue'
import  StepFour from './stepFour.vue'
import  StepFive from './stepFive.vue'
import  StepSix from './stepSix.vue'
import  StepSeven from './stepSeven.vue'
import  StepEight from './stepEight.vue'
import  NineVue from './nine.vue'
import HeaderVue from '../common/header.vue'
import CookieVue from '../common/cookie.vue'

export default {
    components:{HeaderVue,CookieVue,GuideOne, GuideTwo, StepOne,StepTwo, StepThree, StepFour, StepFive, StepSix, StepSeven,StepEight,NineVue},
    data(){
        return{
        imgObj:{
            paperLogo:require("../../assets/img/main/paperLogo.png"),
        },
        currentPage:-1,
        }
    },
    mounted(){
        let  guideIndex = localStorage.getItem('guideIndex');
        console.log('guideIndex',guideIndex)
        if(guideIndex<15 && guideIndex){
            console.log(234)
            this.currentPage = parseInt(guideIndex)
            if( this.currentPage==8){
                this.currentPage =7
            }
        }else{
            console.log(456)
            this.currentPage = -1
        }
    },
    methods:{
        gotoAnchor(id,isFooter){
      this.$router.push({
                path: '/Authors',
                query: {anchor:id}
            });
            return
            console.log('this',id)
            let anchorEl = ''
            if(isFooter){
                let width = window.innerWidth;
                if(width>=1200){
                    anchorEl = document.getElementById(id)
                }else{
                    if(id == 'chargeBox'){
                        if(width<767){
                            anchorEl = document.getElementById(id +'Mobile')

                        }else{
                            anchorEl = document.getElementById(id +'Ipad')
                        }
                    }else{
                        anchorEl = document.getElementById(id +'Ipad')

                    }
                }
            }else{
                anchorEl = document.getElementById(id) }
            anchorEl.scrollIntoView({behavior:'smooth',offsetTop:80,inline:'nearest'})
           
        },
        handlePagechange(index){
            console.log(index,'index')
            if(index>15){
                this.$emit('handleHiddenGuid', index);
            }else{
                this.currentPage = index
            }
        },
        gotoHome(){
            console.log(22)
            if(this.$route.path !== '/Authors'){
                // this.$router.replace('/Authors')
                this.$router.push({path:'/Authors'})
            }
        },
    }
}
</script>


<style lang="scss">
.guideRoot{
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    .titleBlock{
        height: 106px;
        // background: #FFF;
        // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.10);
        background: #fafafa;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, .12);
        display: flex;
        width: 100%;
        // justify-content: ;
        padding: 24px 40px;
        gap: 6px;
        .titleLogo{
            cursor: pointer;
            width: 58px;
            height: 58px;
            display: flex;
            // margin-right: -26px;
        }
        .titleRight{
            cursor: pointer;

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: var(--8, 8px);
            // flex: 1 0 0;
            .mainTitle{
                color: #212121;
                font-size: 28px;
                font-style: normal;
                font-weight: 700;
                line-height: normal
            }
            .subTitle{
                color: #757575;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }
    }
    .itemBlock{
        flex: 1 1;
        overflow: auto;
        position: relative;
        .backIcon{
            position: absolute;
            left: 100px;
            top: 40px;
            display: inline-block;
            .iconItme{
                cursor: pointer;
                font-size: 30px;
            }
            .iconItme:hover{
                color: #feae00;
            }
            .iconItme:active{
                color: #feae00;
            }
        }
    }
}

@media screen and (max-width:767px) { 
    .guideRoot{
        .titleBlock{
            height: 12vw;
            padding: 2vw 3.6vw;
            gap: 6px;
            .titleLogo{
                width: 7.5vw;
                height: 7.5vw;
            }
            .titleRight{
                gap: 1vw;
                .mainTitle{
                    font-size: 3.6vw;
                }
                .subTitle{
                    font-size: 2.6vw;
                }
            }
        }
        .itemBlock{
            .backIcon{
                position: absolute;
                left: 2vw;
                top: 3vw;
                display: inline-block;
                .iconItme{
                    cursor: pointer;
                    font-size: 6vw;
                }
            }
        }
        
    }
}

@media screen  and (min-width: 767px) and (max-width: 1200px){
    .guideRoot{
        .titleBlock{
            height: 9vw;
            padding: 2vw 3.6vw;
            gap: 6px;
            .titleLogo{
                width: 5.5vw;
                height: 5.5vw;
            }
            .titleRight{
                gap: 0.8vw;
                .mainTitle{
                    font-size: 2.6vw;
                }
                .subTitle{
                    font-size: 1.6vw;
                }
            }
        }
        .itemBlock{
            .backIcon{
                position: absolute;
                left: 6vw;
                top: 2vw;
                display: inline-block;
                .iconItme{
                    cursor: pointer;
                    font-size: 3vw;
                }
            }
        }
        
    }
}

</style>